import styles from "./Labels.module.css";

const MetroNet = ({ fontSizeOverride }) => {
  return (
    <p
      style={{ fontSize: fontSizeOverride ? fontSizeOverride : "inherit" }}
      className={styles.logoPrimary}
    >
      metro<span className={styles.highlightText}>net</span>
    </p>
  );
};

export default MetroNet;
